exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cw__primary-overlay-opac[data-v-4cd80f6a]::after {\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: var(--primary);\n  opacity: 0.4;\n}\n", ""]);

// exports
